<template>
  <div>
    <nav class="category-tabs">
      <div class="category-tabs__inner">
        <router-link :to="'/categories/' + category.id_category" class="category-tab" v-for="category in categories">{{category.name_category}}</router-link>
      </div>
    </nav>
    <app-loading v-if="isLoading"></app-loading>
    <main class="card-list main-top-space" v-else>
      <section class="retry-area" v-if="!isResponseSucceeded">
        <h3 class="retry-area__ttl">通信に失敗しました</h3>
        <a href="javascript:void(0);" @click="getCategoryBooks" class="btn-retry btn-retry--short">リトライ</a>
      </section>
      <div v-else>
        <app-book v-for="(book, index) in books" :bookInfo="book" :key="book.id_book + '-category-page-' + index"></app-book>
      </div>
    </main>
  </div>
</template>

<script>
  import TopInformation from '../common/TopInformation.vue';
  import Book from '../books/Book.vue';
  import { categoryTDK } from '../../constants';
  import Loading from '../common/Loading.vue';
  import $ from 'jquery';

  export default {
    headerType: 'default',
    components: {
      appTopInformation: TopInformation,
      appBook: Book,
      appLoading: Loading
    },
    data() {
      return {
        responseError: false
      }
    },
    beforeCreate() {
      this.$store.dispatch("changeLoadingCondition", true);
      const checkCategoryLoaded = setInterval(() => {
        if (this.$store.getters.isCategoryRequestSuceeded) {
          this.$store.dispatch("changeLoadingCondition", false);
          clearInterval(checkCategoryLoaded);
        }
      }, 400);
    },
    created() {
      this.makeTDK();
    },
    mounted() {
      this.setTabWidth();
    },
    updated() {
      this.setTabWidth();
      this.makeTDK();
    },
    methods: {
      makeTDK() {
        const tdkTarget = categoryTDK[this.$route.params.id];
        if (tdkTarget) {
          document.title = tdkTarget.title;
          this.$store.dispatch('changeHeaderTitle', tdkTarget.headerTitle);
          const metaDiscre = document.head.children;
          const metaLength = metaDiscre.length;
          for (let i = 0; i < metaLength; i++) {
            let dis = metaDiscre[i];
          	let proper = dis.getAttribute('name');
          	if (proper === 'description') {
          		dis.setAttribute('content', tdkTarget.description);
          	} else if (proper === 'keywords') {
          		dis.setAttribute('content', tdkTarget.keywords);
            }
          }
        }
      },
      setTabWidth() {
        let categoriesTabWidth = 0;
        $(".category-tab").each((i, e) => {
          let targetLength = $(e).html().length;
          categoriesTabWidth += targetLength * 22;
        });
        $(".category-tabs__inner").css("width", Math.ceil(categoriesTabWidth));
      },
      getCategoryBooks() {
        let token = "";
        if (this.$route.query.token) {
          token = this.$route.query.token;
        }
        this.$store.dispatch('getCategories', {token:token});
      }
    },
    computed: {
      books() {
        return this.$store.getters.categoryBooks(this.$route.params.id);
      },
      isLoading() {
        return this.$store.getters.isLoading;
      },
      categories() {
        return this.$store.getters.categories;
      },
      isResponseSucceeded() {
        return this.$store.getters.isCategoryRequestSuceeded;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/bookList/CategoryDetail.vue